<!-- 新增站点 -->
<template>
  <div class="layout-container" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="form-group-style addSite-form">
        <template>
        <el-form
            class="form-container"
            :model="info"
            :rules="infoRules"
            ref="userInfoForm"
            label-width="80px"
        >
            <h6 class="title">基本信息</h6>
            <el-row :gutter="40">
            <el-col :span="8">
                <div class="form-item">
                <div class="form-label">
                    <span class="label">城市</span>
                    <label class="warn">*</label>
                </div>
                <div class="form-input-item">
                    <el-form-item prop="name">
                        <el-input disabled class="input-control" v-model="cityStr"></el-input>
                    </el-form-item>
                </div>
                </div>
            </el-col>
            <el-col :span="8">
                <div class="form-item">
                <div class="form-label">
                    <span class="label">站点名称</span>
                    <label class="warn">*</label>
                </div>
                <div class="form-input-item">
                    <el-form-item prop="name">
                    <el-input placeholder="请输入站点名称" class="input-control" v-model="info.name"></el-input>
                    </el-form-item>
                </div>
                </div>
            </el-col>
            <el-col :span="8">
                <div class="form-item">
                <div class="form-label">
                    <span class="label">站点拼音</span>
                    <label class="warn">*</label>
                </div>
                <div class="form-input-item">
                    <el-form-item prop="pinyin">
                    <el-input v-model="info.pinyin" placeholder="请输入拼音字母">
                        <div slot="append" @click="getPinyin()">获取</div>
                    </el-input>
                    </el-form-item>
                </div>
                </div>
            </el-col>
            </el-row>
            <el-row :gutter="40">
                <el-col :span="8">
                    <div class="form-item">
                        <div class="form-label">
                            <span class="label">域名</span>
                            <label class="warn">*</label>
                        </div>
                        <div class="form-input-item">
                            <el-form-item prop="domain_pinyin">
                            <el-input v-model="info.domain_pinyin" placeholder="请输入域名" disabled>
                                <div slot="append" @click="getRepeat()">查重</div>
                            </el-input>
                            </el-form-item>
                        </div>
                    </div>
                </el-col>
                <el-col :span="8">
                    <div class="form-item">
                        <div class="form-label">
                            <template>
                                <el-checkbox v-model="info.is_hot_checked">热门站点</el-checkbox>
                            </template>
                        </div>
                    </div>
                </el-col>
                <el-col :span="8">
                    <div class="form-item">
                        <div class="form-label" style="width:120px!important">
                            <span class="label">百度地铁城市id</span>
                            <label class="warn">*</label>
                        </div>
                        <div class="form-input-item" style="width:70%!important">
                            <el-form-item prop="baidu_city_code">
                                <el-input v-model="info.baidu_city_code" placeholder="百度地铁城市数字id，没有请填0"></el-input>
                            </el-form-item>
                        </div>
                    </div>
                </el-col>
            </el-row>
             <el-row :gutter="40">
                <el-col :span="8">
                    <div class="form-item">
                        <div class="form-label">
                            <span class="label">地图标注</span>
                            <label class="warn">*</label>
                        </div>
                        <div class="form-input-item">
                            <el-form-item prop="map_lng_map_lat">
                              <el-input
                                :value="info.map_lng_map_lat"
                                placeholder="请点击获取经纬度"
                              >
                                <div slot="append" @click.stop.prevent="openGetLocation">
                                  获取
                                </div>
                              </el-input>
                            </el-form-item>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </el-form>
        </template>
        <template>
        <div class="form-container">
            <h6 class="title">代理商信息</h6>
            <div class="fixed-data">
            <el-row :gutter="40">
                <el-col :span="8">
                <p class="item">
                    <label>代理商状态:</label>
                    <span>{{info.agent_status}}</span>
                </p>
                </el-col>
                <el-col :span="8">
                <p class="item">
                    <label>代理商:</label>
                    <span>{{info.factor_name}}</span>
                </p>
                </el-col>
                <el-col :span="8">
                <p class="item">
                    <label>代理时间:</label>
                    <span>{{info.sign_date}}</span>
                </p>
                </el-col>
            </el-row>
            </div>
        </div>
        <div class="form-container">
            <h6 class="title">站点400号码</h6>
            <div class="clearfix" style="margin-bottom: 5px">
            <el-button
                class="floatR"
                icon="el-icon-plus"
                @click.prevent.stop="openAddHotline"
            >400号码</el-button>
            </div>
            <el-table 
            :data="hotlineList" 
            stripe 
            ref="multipleTable" 
            style="width: 100%"
            :highlight-current-row="true"
            tooltip-effect="dark"
            header-cell-class-name="table-back"
            >
            <el-table-column label="已绑定400号码" prop="hotline_number"></el-table-column>
            <el-table-column label="号码类型" prop="type_text"></el-table-column>
            <el-table-column label="月最低消费" prop="minimum_charge_yuan"></el-table-column>
            <el-table-column label="分机号位数" prop="telephone_length"></el-table-column>
            <el-table-column fixed="right">
                <!-- 绑定插槽slot="header"用来实现自定义表头,slot-scope="scope"返回数据： score:{row: '', $index: number} -->
                <template slot="header" slot-scope="scope">
                <span style="color: #409EFF">操作</span>
                </template>
                <!-- 默认插槽绑定列表内容插槽 scope: {$index: 当前下标, row: 当前数据对象} -->
                <template slot-scope="scope">
                <el-button size="mini" v-permission="'business.hotline.customerstatusrescission'" @click="handleRescission(scope.$index, scope.row)">解绑</el-button>
                               <el-button size="mini" v-permission="'business.hotline.customerstatusrescission'" @click="openEditHotline(scope.$index,scope.row)">编辑</el-button>
                </template>
            </el-table-column>
            </el-table>
        </div>
        </template>
         <div class="PhoneRecord" v-permission="'business.hotline.log'">
          <div class="search-condition-con">
            <p>400号码操作记录</p>
            <span class="im_btn" v-if="!showRecord" @click="showRecord=!showRecord">
              查看详情
              <i class="el-icon-arrow-down"></i>
            </span>
            <span class="im_btn" v-else @click="showRecord=!showRecord">
              收起详情
              <i class="el-icon-arrow-up"></i>
            </span>
          </div>
         <template  v-if="showRecord">
            <el-table
            ref="multipleTable"
            :data="editData"
            tooltip-effect="dark"
            style="width: 100%"
            v-if="showRecord"
          >
            <el-table-column prop="action_str" label="操作名称" align="center"></el-table-column>
            <el-table-column prop="hotline_number" label="400号码" align="center"></el-table-column>
            <el-table-column prop="hotline_type_str" label="号码类型" align="center"></el-table-column>
            <el-table-column prop="new_minimum_charge_yuan" label="月最低消费" align="center"></el-table-column>
            <el-table-column prop="hotline_length" label="分机号位数" align="center"></el-table-column>
            <el-table-column prop="operator" label="操作人" align="center"></el-table-column>
            <el-table-column prop="created_at" label="操作时间" align="center"></el-table-column>
          </el-table>

            <el-pagination
              background
              layout="total,prev, pager, next"
              :current-page="record.cur_pageage"
              :total="total"
              @current-change="currentChange"
            ></el-pagination>
         </template>

        </div>
        <template>
        <div class="form-container" v-if="siteNavShow">
          <h6 class="title">站点导航显示</h6>
          <div class="fixed-data">
            <span>二手房，小区及租房：</span>
            <el-radio-group v-model="info.menu_extend" size="mini">
              <el-radio :label="1">打开</el-radio>
              <el-radio :label="0">关闭</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div class="form-container">
            <h6 class="title">表单短信校验配置</h6>
            <div class="fixed-data">
                <div style="display: inline-block;">
                  <span style="margin-right:20px">表单短信校验开关</span>
                  <el-radio-group v-model="formSmsCheck" size="mini">
                    <el-radio :label="1">打开</el-radio>
                    <el-radio :label="0">关闭</el-radio>
                  </el-radio-group>
                </div>
            </div>
        </div>
        <h6 class="title">其他设置</h6>
        <div class="site-statics">
            <label>百度竞价OCPC-TOKEN:</label>
              <el-input
                placeholder="百度竞价OCPC-TOKEN"
                class="input-control"
                v-model="info.baidu_ocpc_token"
            ></el-input>
        </div>
        <div class="site-statics">
            <label>PC端百度商桥：</label>
              <el-input
                type="textarea"
                placeholder="PC端百度商桥"
                class="input-control"
                v-model="info.pc_baidu_bridge_code"
            ></el-input>
          
        </div>
          <div class="site-statics">
            <label>M端百度商桥：</label>
              <el-input
                type="textarea"
                placeholder="M端百度商桥"
                class="input-control"
                v-model="info.m_baidu_bridge_code"
            ></el-input>
          
        </div>
          <!--站点文件-->
        <template v-if="showSiteFile">
            <div class="form-container" ref="siteFileForm">
                <h6 class="title">站点文件</h6>
                <div class="clearfix" style="margin-bottom: 5px" v-permission="'business.sites.file'">
                    <el-button
                            type="primary"
                            class="floatR"
                            icon="el-icon-plus"
                            @click.prevent.stop="openAddUpload"
                    >上传文件</el-button>
                </div>
                <el-table
                        :data="siteFileList"
                        stripe
                        ref="multipleTable"
                        style="width: 100%"
                        :highlight-current-row="true"
                        tooltip-effect="dark"
                        header-cell-class-name="table-back"
                >
                    <el-table-column label="文件名" prop="name"></el-table-column>
                    <el-table-column label="上传人" prop="creator"></el-table-column>
                    <el-table-column label="上传时间" prop="created_at"></el-table-column>
                    <el-table-column label="备注" prop="remark">
                       <template slot-scope="scope">
                            <p class="ellips2" :title="scope.row.remark">{{scope.row.remark}}</p>
                        </template>
                    </el-table-column>
                    <el-table-column fixed="right">
                        <!-- 绑定插槽slot="header"用来实现自定义表头,slot-scope="scope"返回数据： score:{row: '', $index: number} -->
                        <template slot="header" slot-scope="scope">
                            <span style="color: #409EFF">操作</span>
                        </template>
                        <!-- 默认插槽绑定列表内容插槽 scope: {$index: 当前下标, row: 当前数据对象} -->
                        <template slot-scope="scope">
                            <el-button size="mini"  v-permission="'business.sites.file'" @click="openEditUpload(scope.row)">编辑</el-button>
                            <el-button size="mini"  v-permission="'business.sites.file'" @click="deleteUpload(scope.$index, scope.row)">删除</el-button>

                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </template>
            <!--站点文件-->
        <div class="form-button">
            <el-button type="primary" @click="submitForm('userInfoForm')">保 存</el-button>
            <el-button type="info" plain @click="backToList()">取 消</el-button>
        </div>
        </template>
        <bindHotline ref="bindHotline" />
        <editHotline ref="editHotline"  :callback="editCallback" />
        <MapLocation :callback="getLocationCallback" ref="locationRef" />
        <upload-file :callback="getSiteFileList" :siteId="siteId" ref ="uploadFileRef" />
    </div>
  </div>
</template>
<script>
import bindHotline from "./bindHotline";
import editHotline from "./editHotline";
import MapLocation from "./map";
import uploadFile from "./uploadFile";

import {
  validateEmpty,
  validateChat,
  validateNumber,
  validateNumberSite
} from "@/utils/validate";
import {
  editSite,
  bindCustomerHotlines,
  getSiteDetail,
  getRepeat,
  getPinyin,
  getCityDetail,
  getSitesFileList,
  deleteSitesFile,
  getSiteSet
} from "@/service/site";
import {
  getFactorCunstomer,
  getCunstomerHotlines,
  CunstomerHotlinesrescission,
  getChargeEditLogs
} from "@/service/hotline";
import { getQueryObject, parseTime } from "@/utils/index";
import { getFactorInfo, getFactorsByName } from "../../../../service/user";
import UploadFile from './uploadFile.vue';

export default {
  name: "add",
  components: {
    bindHotline,
    editHotline,
    MapLocation,
    uploadFile
  },
  data() {
    return {
      fullscreenLoading:false,
      edit: true,
      siteId:'',
      map_lng_map_lat:'',
      info: {
        name: "",
        pinyin: "",
        domain_pinyin: "",
        baidu_city_code: "",
        is_hot_checked: false,
        map_lng_map_lat:'',
        menu_extend:"",
      },
      infoRules: {
        name: [
          {
            required: true,
            validator: validateEmpty,
            result: "站点名称",
            trigger: "blur"
          },
          {
            required: true,
            validator: validateChat,
            type: 1,
            result: "站点名称",
            max: 15
          }
        ],
        pinyin: [
          {
            required: true,
            validator: validateEmpty,
            result: "站点拼音",
            trigger: "blur"
          },
          {
            required: true,
            validator: validateChat,
            type: 2,
            result: "站点拼音"
          }
        ],
        domain_pinyin: [
          {
            required: true,
            validator: validateEmpty,
            result: "域名",
            trigger: "blur"
          },
          { required: true, validator: validateChat, type: 2, result: "域名" }
        ],
        map_lng_map_lat: [
          { required: true, message: "请输入地图标注", trigger: "change" }
        ],
        baidu_city_code: [
          {
            required: true,
            message: "百度地铁城市数字id，没有请填0",
            trigger: "blur"
          },
          {
            validator: validateNumberSite,
            type: 3,
            min: 0,
            max: 999999999,
            result: "百度地铁城市数字id"
          }
        ]
      },
      provinceList: [],
      citiesList: [],
      hotlineList: [],
      newHotlineList: [],
      city_id: "",
      cities: [],
      cityStr: "",
      feeStatus:1,//欠费状态
      showRecord:false,//操作记录
      recordList:[],//操作记录
      editData:null,
      total:0,
      formSmsCheck:"",
      record: {
        page: 1,
       
      },
      siteFileList:[],//站点校验文件
      showSiteFile:true,//豪宅、别墅隐藏站点验证文件功能
      siteNavShow:false,//淘房网站点可配置”二手房、租房、小区“导航入口
    };
  },
  mounted() {
    let domain=document.domain
    let host = window.serverConfig[window.siteMap[domain]].HOST;
    if(host=='bieshu.com' || host == 'haozhai.com'){
        this.showSiteFile = false;
    }
    if(host=='taofang.com'){
      this.siteNavShow = true
    }
    this.getData();
  },
  methods: {
    getLocationCallback (longitude, latitude) {
        this.$set(this.info, "map_lng_map_lat", longitude + "   " + latitude);
        this.$set(this.info, "map_lng", longitude);
        this.$set(this.info, "map_lat", latitude);
        this.$forceUpdate()
    },
    openGetLocation () {
      this.$refs.locationRef && this.$refs.locationRef.openDialog(this.info.map_lng, this.info.map_lat,this.info.name,this.cityStr);
    },
    backToList() {
      this.$router.push("list");
    },
    getPinyin() {
      if (this.info.name.length == 0) {
        this.$message({
          message: "站点名不能为空",
          type: "error",
          duration: 3 * 1000
        });
        return false;
      }
      let query = {
        name: this.info.name
      };
      getPinyin(query).then(data => {
        this.info.pinyin = data;
      });
    },
    getRepeat() {
      if (this.info.domain_pinyin.length == 0) {
        this.$message({
          message: "域名不能为空",
          type: "error",
          duration: 3 * 1000
        });
        return false;
      }
      let query = {
        domain_pinyin: this.info.domain_pinyin,
        id: this.info.id
      };
      getRepeat(query).then(data => {
        if (data.status == "0") {
          this.$message({
            message: "该域名可使用",
            type: "success",
            duration: 3 * 1000
          });
        } else {
          this.$message({
            message: "该域名重复，请重新输入域名",
            type: "error",
            duration: 3 * 1000
          });
        }
      });
    },
    async getData() {
      this.fullscreenLoading=true;
      let query = getQueryObject();
      if (!query.id) {
        this.$router.push("list");
      }
      this.siteId = query.id;
      await getSiteDetail(query.id).then(data => {
        data.is_hot_checked = data.is_hot == 1 ? true : false;
        this.info = data;
        this.info.map_lng_map_lat=data.map_lng + '  ' + data.map_lat;
      });
      await getFactorInfo(this.info.factor_id).then(data => {
        this.info.factor_name = data.name;
        this.feeStatus =data.fee_status;
        if (this.info.factor_id > 1) {
            this.info.sign_date =
              parseTime(data.sign_start_time, "{y}-{m}-{d}") +
              " 至 " +
              parseTime(data.sign_end_time, "{y}-{m}-{d}");
        } else {
            this.info.sign_date = '';
        }
      });
      this.info.agent_status = this.info.factor_id != 1 ? "已代理" : "未代理";
      await getFactorCunstomer(this.info.factor_id, {
        service_id: this.info.id,
        status:0
      }).then(data => {
        if (data.data.length > 0) {
          this.info.customer_id = data.data[0].id;
        } else {
          this.info.customer_id = 0;
          this.$message({
            message: "当前站点未正确绑定400商户",
            type: "error",
            duration: 3 * 1000
          });
        }
      });

      await this.setCities(this.info.city_id);

      if (this.info.customer_id > 0) {
        await getCunstomerHotlines(this.info.customer_id, {
          per_page: 100
        }).then(data => {
          for (let i in data.data) {
            let pamams = data.data[i];
            // 排除已解约的号
            if (pamams.status != 2) {
              if (pamams.hotline_type == 1) {
                pamams.type_text = "独立大号";
              } else {
                pamams.type_text = "公共大号";
              }
              if (pamams.only_user_400 == 1) {
                pamams.hotline_number += '（直拔号）';
              }
              pamams.minimum_charge = pamams.minimum_charge_yuan;
              this.hotlineList.push(pamams);
            }
          }
        });
      }
      await getSiteSet(query.id).then(data => {
        this.formSmsCheck = data.form_sms_check;
      });
      this.fullscreenLoading=false;
    //最低消费编辑记录
      this.getRecordList()
      this.getSiteFileList()

    },
    async getSiteFileList(){ //站点验证文件列表
      let query={};
      query.site_id  = this.siteId ;
      await getSitesFileList(query).then(data => {
          this.siteFileList = data;
      });
    },
    openAddUpload(){
      this.$refs.uploadFileRef && this.$refs.uploadFileRef.open()
    },
    openEditUpload(row){
       this.$refs.uploadFileRef && this.$refs.uploadFileRef.open(row)
    },
    deleteUpload(index,row){ //删除站点文件
      this.$confirm('是否删除'+row.name+'文件?', '提示').then(_ => {
              deleteSitesFile(row.id).then((data) => {
                  this.$message({
                      message: '删除成功',
                      type: 'success',
                      duration: 3 * 1000
                  });
                  // 删除指定下标开始一条数据
                  this.siteFileList.splice(index, 1)
              }).catch(err => {
                  this.$message({
                      message: err.message || '删除失败',
                      type: 'error',
                      duration: 3 * 1000
                  })
              })
          }).catch(_ => {

      })
    },
    getRecordList(){
      this.record.site_id=this.info.id
       getChargeEditLogs(this.record).then(data => {
        if(data.data.length>0){
          data.data.forEach(el=>{
            el.new_minimum_charge_yuan=el.new_minimum_charge/100
          })
        }
        this.total = parseInt(data.total);
        this.editData=data.data
       
      });
    },
    currentChange(index) {
      this.record.page = index;
      this.getRecordList()
    },
    openAddHotline() {
      if(this.feeStatus==1){
         this.$message({
            message:"代理商已欠费不可绑定400号码",
            type: "warning",
            duration: 3 * 1000
          });
        return false;
      }
      let data = {
        id: "",
        type: "",
        hotline_number: "",
        minimum_charge: "",
        telephone_length: "",
        site_id: this.info.id,
        minimum_charge_yuan: "",
      };
      this.$refs.bindHotline &&
        Object.assign(this.$refs.bindHotline.hotlineInfo, data) &&
        this.$refs.bindHotline.open();
    },
    appendHotline(pamams) {
      if (pamams.type == 1) {
        pamams.type_text = "独立大号";
      } else {
        pamams.type_text = "公共大号";
      }
      if (pamams.only_user_400 == 1) {
        pamams.hotline_number += '（直拔号）';
      }
      this.hotlineList.push(pamams);
      this.newHotlineList.push(pamams);
    },
    openEditHotline(index,row){
      const result = Object.assign({}, {}, row)
      this.$refs.editHotline && this.$refs.editHotline.open(result,index)
    },
    editCallback(list,index){
      this.$set(this.hotlineList, index, list)
      this.$set(this.newHotlineList, index, list)
     
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let query = this.info;
          query.is_hot = this.info.is_hot_checked == true ? 1 : 2; // 热门站点
          query.operator_id = this.$store.state.user.userInfo.id;
          query.operator = this.$store.state.user.userInfo.name;
          query.form_sms_check = this.formSmsCheck
          editSite(query.id, query)
            .then(data => {
              query.customer_id = data.customer_id;
              if (this.hotlineList.length > 0) {
                query.hotline = this.hotlineList;
                bindCustomerHotlines(query)
                  .then(data => {
                    this.$message({
                      message: "绑定400号码成功",
                      type: "success",
                      duration: 3 * 1000
                    });
                    this.$router.push("list");
                  })
                  .catch(err => {
                    this.$message({
                      message: err.message || "绑定400号码失败",
                      type: "error",
                      duration: 3 * 1000
                    });
                  });
              } else {
                this.$message({
                  message: "站点更新成功",
                  type: "success",
                  duration: 3 * 1000
                });
                this.$router.push("list");
              }
            })
            .catch(err => {
              console.log(err);
              this.$message({
                message: err.message || "更新失败",
                type: "error",
                duration: 3 * 1000
              });
            });
        } else {
          return false;
        }
      });
    },
    // 解绑-取消分配
    handleRescission(i, row) {
      this.$confirm(
        "取消分配后将解除该400号码与站点以及分机号所有的绑定关系，不可恢复，是否确认操作？",
        "提示",
        {
          confirmButtonText: "确定",
          type: "warning"
        }
      )
        .then(() => {
          // 清除行
          this.hotlineList.splice(i, 1); // 这个用于显示
          this.newHotlineList = this.removeHotline(this.newHotlineList, row); // 这个用于提交

          if (parseFloat(row.id).toString() != "NaN") {
            // 已经绑定入库的
            let query = {};
            query["status"] = 1;
            CunstomerHotlinesrescission(row.id, query).then(data => {
              // this.refreshPage()
            });
            this.isLoading = false;
          } else {
            // 新增未入库的
          }
        })
        .catch(e => {});
    },
    // 移除数组中解绑的当前行400
    removeHotline(newHotlineList, row) {
      let index = -1;

      // 查找当前行在数组中所在的位置
      for (var i = 0; i < newHotlineList.length; i++) {
        if (newHotlineList[i]["hotline_number"] == row["hotline_number"]) {
          index = i;
        }
      }

      // 移除
      if (index > -1) {
        newHotlineList.splice(index, 1);
      }

      return newHotlineList;
    },
    // 当前城市
    setCities(city_id) {
      getCityDetail(city_id)
        .then(data => {
          this.cities.push({
            id: data.id,
            name: data.name
          });
          this.city_id = data.id;
          this.cityStr = data.name + " " + this.cityStr;
          if (data.up_id > 0) {
            this.setCities(data.up_id)
          } else {
            this.cities.reverse();
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
  }
};
</script>
<style  lang="less">
.addSite-form{
    padding: 20px;
    background-color: #fff;
    border-top:1px solid #ddd;
}
.title {
  margin-top: 0px !important;
  font-size: 18px !important;
  color: #1a1a1a !important;
  padding: 5px 20px 0px !important;
  font-weight: normal !important;
}
.addSite-form .form-container .form-item .form-label {
  width: 80px !important;
  text-align: left!important;
}
.el-form-item__content {
  margin-left: 0 !important;
}
.addSite-form .form-container .form-input-item {
  width: 80% !important;
}
.form-container .fixed-data {
  padding: 20px 0;
}
.form-container .fixed-data p,
.form-container .fixed-data span {
  color: #333;
  font-size: 14px;
  line-height: 36px;
}
.addSite-form .form-container .fixed-data p label {
  width: 100px !important;
  text-align: left;
  display: inline-block;
}
// .layout-container{
//     padding:20px;
//     background: #FFF;
//     border: 1px solid #DCDFE6;
//     box-shadow: 0 2px 4px 0 rgba(0,0,0,.12), 0 0 6px 0 rgba(0,0,0,.04);
// }
.addSite-form h6.title{
    padding:0!important;
    font-size:16px!important;
    font-weight: bold!important;
}
.PhoneRecord {
  margin-top: 30px;
}
.PhoneRecord p{
  margin-top:7px;
}
.PhoneRecord span {
  padding: 10px;
  color: #999;
}
.PhoneRecord span .iconfont {
  font-size: 20px;
  margin-left: 10px;
}
.im_btn {
    position: absolute;
    right: 20px;
}
.search-condition-con{
  position: relative;
}
.site-statics{
    margin-top:30px;
}
.site-statics{
    display: flex;
}
.site-statics label{
    display: inline-block;
    font-size: 14px;
    width:180px;
}
.ellips2{
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    max-height:45px;
}
</style>